import { CheckCircle, XCircle, Clock } from "@semo/icons";
import { ContractResponseDtoStatus } from "@semo/api-contracts";

export type ContractStatus = ContractResponseDtoStatus;

/**
 * 계약 상태별 UI 설정
 * 디자인 시스템(Primary 컬러 및 Gray 스케일)에 맞춰 통합
 */
export const CONTRACT_STATUS_CONFIG: Record<
  ContractStatus,
  {
    label: string;
    color: string;
    textColor: string;
    bgColor: string;
    borderColor: string;
    icon: any;
    darkTextColor: string;
    darkBgColor: string;
    darkBorderColor: string;
  }
> = {
  IN_PROGRESS: {
    label: "진행중",
    color: "bg-primary",
    textColor: "text-primary",
    bgColor: "bg-primary/5",
    borderColor: "border-primary/20",
    icon: Clock,
    darkTextColor: "text-primary",
    darkBgColor: "bg-primary/20",
    darkBorderColor: "border-primary/30",
  },
  COMPLETED: {
    label: "완료",
    color: "bg-green-500",
    textColor: "text-green-600",
    bgColor: "bg-green-50",
    borderColor: "border-green-200",
    icon: CheckCircle,
    darkTextColor: "text-green-400",
    darkBgColor: "bg-green-500/20",
    darkBorderColor: "border-green-500/30",
  },
  CANCELED: {
    label: "취소됨",
    color: "bg-red-500",
    textColor: "text-red-600",
    bgColor: "bg-red-50",
    borderColor: "border-red-200",
    icon: XCircle,
    darkTextColor: "text-red-400",
    darkBgColor: "bg-red-500/20",
    darkBorderColor: "border-red-500/30",
  },
};
